import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals }) {


  //console.log("Grand Total", totals);
  const parseAmount = (value) => {
    if (value == null) return 0;

    let str = String(value).replace(/,/g, "").trim();

    // Handle trailing minus
    if (str.endsWith("-")) {
      str = "-" + str.slice(0, -1);
    }

    return Number(str) || 0;
  };


  //const totalLabour = (parseAmount(totals.DirectLabour) || 0) + (parseAmount(totals.OnCostLabour) || 0);
  //const totalStore = (parseAmount(totals.DirectStore) || 0) + (parseAmount(totals.OnCostStore) || 0);

  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >


      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >





        <Grid size={{ xs: 12, md: 12 }}>
          <TableContainer
            component={Paper}
            variant="outlined"
           
          >
            <Table size="small">
              {/* SUMMARY HEADER */}
              <TableHead>
                <TableRow>
                  {/* Empty description header */}
                  <TableCell
                    sx={{
                      bgcolor: "grey.200",
                      width: "30%",
                      border: "1px solid #999",
                    }}
                  />

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    WO No
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    LOCO
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    C&W
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                      
                    }}
                  >
                   MISC
                  </TableCell>

                   <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                      width:100,
                    }}
                  >
                           
                  </TableCell>
                </TableRow>
              </TableHead>

              {/* SUMMARY BODY */}
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      border: "1px solid #999",
                    }}
                  >
                    No. WA/SL/Repair Cost
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* WO No value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* LOCO value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* C&W value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                   <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      border: "1px solid #999",
                    }}
                  >
                    Dy CME Repair
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* WO No value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* LOCO value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* C&W value */}
                  </TableCell>
 <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      border: "1px solid #999",
                    }}
                  >
                    No. WA/SL/Repair Cost

                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* WO No value */}
                  </TableCell>
 <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* LOCO value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* C&W value */}
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                </TableRow>


                <TableRow>
                  <TableCell
                    align="right"
                    sx={{
                      border: "1px solid #999",
                      height: 30,
                      verticalAlign: "top",
                    }}
                  />

                  <TableCell
                    align="right"
                    sx={{
                      border: "1px solid #999",
                      height: 30,
                      verticalAlign: "top",
                    }}
                  />

                  <TableCell
                    align="right"
                    sx={{
                      border: "1px solid #999",
                      height: 30,
                      verticalAlign: "top",
                    }}
                  />

                  <TableCell
                    align="right"
                    sx={{
                      border: "1px solid #999",
                      height: 30,
                      verticalAlign: "top",
                    }}
                  />
 <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    {/* MISC value */}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      border: "1px solid #999",
                      height: 30,
                      verticalAlign: "top",
                    }}
                  />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

       
        

      </Grid>

       <Box sx={{ mt: 25,mb:5, textAlign: "right", pr: 5 }}>
  for FA&CAO/W
</Box>
    </Paper>
  );
}